import axios from 'axios';
import { routerHistory } from 'utils/helpers';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_SERVER_URL,
  headers: {
    'content-type': 'application/json'
  }
});
const logoutUser = () => {
  localStorage.removeItem('token');
  // routerHistory.navigate(`/login`);
};

// Request interceptor to add auth token from sessionStorage for partner sessions
// Regular users continue to pass token explicitly to API functions
axiosInstance.interceptors.request.use(
  (config) => {
    // Skip auth for requests with X-Skip-Auth header (like deeplink validation)
    if (config.headers['X-Skip-Auth']) {
      delete config.headers['X-Skip-Auth'];
      return config;
    }

    // Only add token from sessionStorage if Authorization header is not already set
    // This allows partner sessions to work while not breaking existing flows
    if (!config.headers.Authorization || 
        config.headers.Authorization === 'Bearer undefined' || 
        config.headers.Authorization === 'Bearer null' ||
        config.headers.Authorization.includes('undefined') ||
        config.headers.Authorization.includes('null')) {
      
      // Try to get token from sessionStorage (for partner sessions)
      let token = sessionStorage.getItem('auth_token');
      let isPartnerSession = sessionStorage.getItem('is_partner_session');
      
      
      
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        
      } else {
        // Remove invalid Authorization header if it exists
        if (config.headers.Authorization && 
            (config.headers.Authorization.includes('undefined') || 
             config.headers.Authorization.includes('null'))) {
          delete config.headers.Authorization;
          
        }
        
        if (isPartnerSession) {
          console.error('❌ Partner session detected but no auth_token found in sessionStorage!');
        }
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.config.responseType !== 'blob') {
      return response;
    }

    const blob = new Blob([response.data], { type: response.headers['content-type'] });

    const blobUrl = window.URL.createObjectURL(blob);

    response.data = blobUrl;

    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      console.error('401 Unauthorized error:', {
        url: error.config?.url,
        method: error.config?.method,
        hasAuthHeader: !!error.config?.headers?.Authorization,
        authHeader: error.config?.headers?.Authorization?.substring(0, 50),
        isPartnerSession: sessionStorage.getItem('is_partner_session'),
        hasToken: !!sessionStorage.getItem('auth_token')
      });
      
      // Don't auto-clear sessionStorage - let the app handle it
      // const isPartnerSession = sessionStorage.getItem('is_partner_session');
      // if (isPartnerSession) {
      //   sessionStorage.clear();
      //   alert('Session expired. Please request a new link from your portal.');
      //   window.close();
      // } else {
      //   logoutUser();
      // }
    }
    return Promise.reject(error);
  }
);

export const getUserDevices = (token) => {
  return axiosInstance({
    method: 'GET',
    url: '/api/device',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      if (error?.response?.data?.status === 401) {
        logoutUser();
      }
      return {
        status: error?.response?.data?.status,
        errorMessage: error.errorMessage,
        error: true
      };
    });
};

export const login = (data) =>
  axiosInstance({
    method: 'POST',
    url: '/api/login',
    data: { ...data },
    headers: {
      'content-type': 'application/json' // override axiosInstance defaults
    }
  })
    .then((res) => {
      localStorage.setItem('org_name', res.data?.data?.user_data?.organization?.organization_name);
      return res.data;
    })
    .catch((error) => {
      console.error('error', error)
      if (error?.response?.data?.status === 401) {
        logoutUser();
      }
      throw new Error(error?.response?.data?.message || 'Something went wrong during login.');
      /* return {
        status: error?.response?.data?.status,
        errorMessage: error?.response?.data?.message,
        error: true
      }; */
    });

export const resetUserPassword = async (data) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      url: '/api/resetPassword',
      data: { ...data },
      headers: {
        'content-type': 'application/json' // override axiosInstance defaults
      }
    });

    if (response) {
      // console.log(response);
      return response;
    }
  } catch (error) {
    return {
      status: error?.response?.data?.status,
      errorMessage: error.errorMessage,
      error: true
    };
  }
};
export const changeUserPassword = async (data, token) => {
  try {
    const response = await axiosInstance({
      method: 'POST',
      url: '/api/changePassword',
      data: { ...data },
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    });

    if (response) {
      return response;
    }
  } catch (error) {
    console.error('error occured', error);
    return {
      status: error?.response?.status, // status should come from the response status
      message: error?.response?.data?.message || 'An error occurred during changing password!', // Changed to message
      error: true
    };
  }
};

export const createUser = (data) =>
  axiosInstance({
    method: 'POST',
    url: '/api/createUser',
    data: { ...data },
    headers: {
      'content-type': 'application/json' // override axiosInstance defaults
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return {
        status: error?.response?.data?.status,
        errorMessage: error?.response?.data?.message || error.errorMessage,
        error: true
      };
    });

export const deleteUser = (token) =>
  axiosInstance({
    method: 'delete',
    url: '/api/deleteUser',
    data: {},
    headers: {
      'content-type': 'application/json', // override axiosInstance defaults
      Authorization: `Bearer ${token}`
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return {
        status: error?.response?.data?.status,
        errorMessage: error?.response?.data?.message || error.errorMessage,
        error: true
      };
    });
export const addDevice = (data, token) =>
  axiosInstance({
    method: 'POST',
    url: '/api/addDevice',
    data: { ...data },
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return {
        status: error?.response?.status, // status should come from the response status
        message: error?.response?.data?.message || 'An error occurred during adding device!', // Changed to message
        error: true
      };
    });

export const deleteDevice = (data, token) =>
  axiosInstance({
    method: 'delete',
    url: `/api/device/delete`,
    data: { ...data },
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then((res) => {
      // console.log('res', res);
      return res.data;
    })
    .catch((error) => {
      // console.log('error', error);
      return {
        status: error?.response?.status, // status should come from the response status
        message: error?.response?.data?.message || 'An error occurred during deleting device!', // Changed to message
        error: true
      };
    });

export const getUserProfile = (token) => {
  return axiosInstance({
    method: 'GET',
    url: '/api/userProfile',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return {
        status: error?.response?.data?.status,
        errorMessage: error?.response?.data?.message || error.errorMessage,
        error: true
      };
    });
};

export const updateUserTimezone = (timezone, token) =>
  axiosInstance({
    method: 'POST',
    url: '/api/user/timezone',
    data: { timezone },
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then((res) => res.data)
    .catch((error) => ({
      status: error?.response?.data?.status ?? error?.response?.status,
      errorMessage: error?.response?.data?.message || error?.message,
      error: true
    }));

export const logout = (token) =>
  axiosInstance({
    method: 'GET',
    url: '/api/logout',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });

export const forgotPassword = (email, org_name) =>
  axiosInstance({
    method: 'POST',
    url: '/api/forgotPassword',
    data: { email: email, org_name: org_name },
    headers: {
      'content-type': 'application/json'
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return {
        status: error?.response?.data?.status,
        errorMessage: error?.response?.data?.message || error.errorMessage,
        error: true
      };
    });

export const downloadUsageReport = async (data, token) => {
  const response = await axiosInstance.post(
    '/api/usage-report',
    { ...data },
    {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return response;
};

export const updateDeviceName = (data, token) =>
  axiosInstance({
    method: 'POST',
    url: '/api/device/update',
    data: { ...data },
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return {
        status: error?.response?.status, // status should come from the response status
        message: error?.response?.data?.message || 'An error occurred during setting device name!', // Changed to message
        error: true
      };
    });

// Partner Integration API - Validate Deeplink Token
// This endpoint should NOT have Authorization header
export const validateDeeplinkToken = (token) =>
  axiosInstance({
    method: 'GET',
    url: `/api/integrations/deeplink/validate?token=${token}`,
    headers: {
      'content-type': 'application/json',
      'X-Skip-Auth': 'true'  // Flag to skip auth interceptor
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      throw error;
    });

// Get device by IMEI for partner sessions
export const getDeviceByIMEI = (imei, token) =>
  axiosInstance({
    method: 'GET',
    url: `/api/device/IMEI/${imei}`,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return {
        status: error?.response?.status,
        errorMessage: error?.response?.data?.message || 'Error fetching device',
        error: true
      };
    });

// Partner Customer Invite - Validate Invite Token
// This endpoint should NOT have Authorization header
export const validateInviteToken = (token) =>
  axiosInstance({
    method: 'GET',
    url: `/api/partner-customer/invite?token=${token}`,
    headers: {
      'content-type': 'application/json',
      'X-Skip-Auth': 'true'  // Flag to skip auth interceptor
    }
  })
    .then((res) => {
      // Ensure response has status property for consistent handling
      // If backend response doesn't include status, add it from HTTP status code
      const responseData = res.data || {};
      if (!responseData.hasOwnProperty('status')) {
        responseData.status = res.status || 200;
      }
      return responseData;
    })
    .catch((error) => {
      const responseData = error?.response?.data || {};
      return {
        status: error?.response?.status || 500,
        errorMessage: responseData.message || 'Failed to validate invite token',
        error: true,
        data: responseData.data ?? null
      };
    });

// Partner Customer Invite - Resend Invite
// This endpoint should NOT have Authorization header
export const resendPartnerInvite = (data) =>
  axiosInstance({
    method: 'POST',
    url: '/api/partner-customer/invite/resend',
    data: { ...data },
    headers: {
      'content-type': 'application/json',
      'X-Skip-Auth': 'true'
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return {
        status: error?.response?.status || 500,
        errorMessage: error?.response?.data?.message || 'Failed to resend invite',
        error: true,
        data: null
      };
    });

// Partner Customer Invite - Set Password
// This endpoint should NOT have Authorization header
export const setPartnerPassword = (data) =>
  axiosInstance({
    method: 'POST',
    url: '/api/partner-customer/set-password',
    data: { ...data },
    headers: {
      'content-type': 'application/json',
      'X-Skip-Auth': 'true'  // Flag to skip auth interceptor
    }
  })
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return {
        status: error?.response?.status || 500,
        errorMessage: error?.response?.data?.message || 'Failed to set password',
        error: true,
        data: null
      };
    });

// Partner OAuth token exchange for integration calls.
export const getPartnerAccessToken = (payload) =>
  axiosInstance({
    method: 'POST',
    url: '/api/oauth/token',
    data: { ...payload },
    headers: {
      'content-type': 'application/json',
      'X-Skip-Auth': 'true'
    }
  })
    .then((res) => res.data)
    .catch((error) => ({
      status: error?.response?.status || 500,
      errorMessage: error?.response?.data?.message || 'Failed to generate partner access token',
      error: true,
      data: null
    }));

// Partner telemetry API with strict partner/device scoping.
export const getPartnerTelemetryLatest = (externalDeviceId, token, types = []) => {
  const typeList = Array.isArray(types)
    ? types.filter((type) => typeof type === 'string' && type.trim()).join(',')
    : '';
  const queryString = typeList ? `?types=${encodeURIComponent(typeList)}` : '';

  return axiosInstance({
    method: 'GET',
    url: `/api/integrations/devices/${encodeURIComponent(externalDeviceId)}/telemetry/latest${queryString}`,
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then((res) => res.data)
    .catch((error) => ({
      status: error?.response?.status || 500,
      errorMessage: error?.response?.data?.message || 'Failed to fetch partner telemetry',
      error: true,
      data: null
    }));
};
